exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__loadingContainer___2xNMs {\n  text-align: center;\n  vertical-align: middle;\n  padding: 40px; }\n  .style__loadingContainer___2xNMs > div {\n    margin-top: 20px;\n    display: inline-block; }\n\n.style__size-normal___36AEV {\n  width: 50%; }\n\n.style__size-large___2RuvD {\n  width: 80%; }\n\n.style__size-small___3q78L {\n  width: 30%; }\n", ""]);

// exports
exports.locals = {
	"loadingContainer": "style__loadingContainer___2xNMs",
	"size-normal": "style__size-normal___36AEV",
	"size-large": "style__size-large___2RuvD",
	"size-small": "style__size-small___3q78L"
};